import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function HappyFeedback({feedback}) {
    return (
        <div
            className='happy-face'
            style={{opacity: feedback ? '1' : '0'}}
        ></div>
    );
}

export default HappyFeedback;
